import Cookies from "js-cookie";

export const clearCookie = () => {
  const options = {
    path: "/", // Specify the path
    domain: ".phactmi.org" // Specify the domain (if applicable)
  };

  // Remove the cookie
  Cookies.remove("phactmi-bounded", options);
  Cookies.remove("phactmi-user", options)
  Cookies.remove("phactmi-bounded-reset", options)
  Cookies.remove("phactmi-bounded-sub", options)
};

export const setParentDomainCookie = (value, refreshToken, sub, user) => {
  const cookieName = "phactmi-bounded";
  const cookieValue = value;
  const options = {
    expires: 1, // Expires in 1 days
    path: "/", // Cookie path
    domain: ".phactmi.org", // Set the domain to the parent domain
    secure: true // Set to true if using HTTPS
  };

  const userCookieName = "phactmi-user"
  const userCookieValue = user

  const resetTokenCookie = "phactmi-bounded-reset"
  const resetTokenCookieValue = refreshToken

  const subCookie = "phactmi-bounded-sub"
  const subCookieValue = sub

  if (cookieValue) {
    Cookies.set(cookieName, cookieValue, options);
  }
  if ( userCookieValue) {
    Cookies.set(userCookieName, userCookieValue, options)
  }
  if (resetTokenCookieValue) {
    Cookies.set(resetTokenCookie, resetTokenCookieValue, options)
  }
  if (subCookieValue) {
    Cookies.set(subCookie, subCookieValue, options)
  }
};

export const getCookie = () => {
  return {
    token: Cookies.get("phactmi-bounded"),
    reset: Cookies.get("phactmi-bounded-reset"),
    sub: Cookies.get("phactmi-bounded-sub"),
    user: Cookies.get("phactmi-user")
  }
}